import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
  },
  header: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  scrollWrapper: {
    position: 'relative',
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    overflowX: 'auto',
    paddingBottom: theme.spacing(1),
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      height: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.superLight,
      borderRadius: 4,
    },
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.secondary.superLight}`,
    boxShadow: theme.shadows[2],
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  navPrev: {
    left: -18,
  },
  navNext: {
    right: -18,
  },
  emptyBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(6, 2),
    textAlign: 'center',
  },
  emptyTitle: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  emptySubtitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    maxWidth: 440,
  },
  noResults: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    padding: theme.spacing(3, 0),
  },
  noResultsBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(5, 2, 6),
    textAlign: 'center',
  },
  noResultsQuery: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  noResultsIconWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(3),
  },
  noResultsX: {
    position: 'absolute',
    left: 17,
    top: 17,
  },
  noResultsTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  noResultsSubtitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    maxWidth: 420,
    marginBottom: theme.spacing(3),
  },
  noResultsActions: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  browseCategoryButton: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 2.5),
  },
  clearSearchButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 2.5),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))

export default useStyles
